import { render, staticRenderFns } from "./SendRecommendation.vue?vue&type=template&id=76d49f5a&"
import script from "./SendRecommendation.vue?vue&type=script&lang=js&"
export * from "./SendRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./SendRecommendation.vue?vue&type=style&index=0&id=76d49f5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports